<template lang="pug">
  b-modal#updateMemberProfile(
  ref="updateMemberProfile"
  :title="$t('ui.combine.update_member_profile')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  ok-only
  @show="reset"
  @shown="shown")
    b-form(novalidate :disabled="!feedback.success")
      b-form-group(:label="$t('ui.account_id')" disabled).mb-3
        DebounceInput(
          size="sm"
          ref="account_id"
          required
          alphaNum
          type="text"
          :dirty="$v.account_id.$dirty"
          :error="$v.account_id.$error"
          v-model.trim.lazy="$v.account_id.$model"
          :disabled="loading"
          :maxLength="$v.account_id.$params.maxLength.max"
        )
        ValidateResult(:value="$v.account_id" :name="$t('ui.account_id')")
      b-form-group.mb-3
        div.row.mb-3.animated.fadeIn
          div.col
            table.tablex(style="width: 100%;")
              thead
                tr
                  th
                    span {{ $t('ui.type') }}
                  th.text-center
                    span {{ $tc('ui.value', 1) }}
              tbody
                tr
                  td
                    span.font-weight-bold.text-uppercase {{ $t("ui.withdrawal_limit") }}
                  td
                    b-form-select(
                      size="sm"
                      ref="withdrawal_limit"
                      :dirty="$v.withdrawal_limit.$dirty"
                      :error="$v.withdrawal_limit.$error"
                      v-model.trim.lazy="$v.withdrawal_limit.$model"
                      :disabled="loading"
                      @change="changeWithdrawalLimit($event)"
                      )
                      option(value="" disabled selected) {{ $t("message.select_option") }}
                      option(v-for="option in wlOptions" :value="option.limit_id") {{ option.limit_name }}
                    ValidateResult(:value="$v.withdrawal_limit" :name="$t('ui.withdrawal_limit')")
                tr
                  td
                    span.font-weight-bold.text-uppercase {{ $t("ui.bank_group") }}
                  td
                    b-form-select(
                      size="sm"
                      ref="bank_group"
                      :dirty="$v.bank_group.$dirty"
                      :error="$v.bank_group.$error"
                      v-model.trim.lazy="$v.bank_group.$model"
                      :disabled="loading"
                      @change="changeBankGroup()"
                      )
                      option(value="" disabled selected) {{ $t("message.select_option") }}
                      option(v-for="option in bgOptions" :value="option.group_id") {{ option.group_name }}
                    ValidateResult(:value="$v.bank_group" :name="$tc('ui.bank_group')")
                tr
                  td
                    span.font-weight-bold.text-uppercase {{ $t("ui.promotion_group") }}
                  td
                    b-form-select(
                      size="sm"
                      ref="promotion_group"
                      :dirty="$v.promotion_group.$dirty"
                      :error="$v.promotion_group.$error"
                      v-model.trim.lazy="$v.promotion_group.$model"
                      :disabled="loading"
                      @change="changePromotionGroup()"
                      )
                      option(value="" disabled selected) {{ $t("message.select_option") }}
                      option(v-for="option in pgOptions" :value="option.group_id") {{ option.group_name }}
                    ValidateResult(:value="$v.promotion_group" :name="$t('ui.promotion_group')")
      div.row
        div.col
          b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, email, sameAs } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    item: {
      type: Object
    },
  },
  data() {
    return {
      account_id: '',
      loading: false,
      withdrawal_limit: '',
      bank_group: '',
      promotion_group: '',
      feedback: {
        success: true,
        status: ""
      },
      pgOptions: [],
      bgOptions: [],
      wlOptions: []
    };
  },
  computed: {

  },
  validations: {
    account_id: {
      required,
      alphaNum,
      maxLength: maxLength(20)
    },
    withdrawal_limit: {
      required
    },
    bank_group: {
      required
    },
    promotion_group: {
      required
    }
  },
  methods: {
    changePromotionGroup() {
      this.$helpers
        .alert({
          title: this.$t("ui.promotion_group"),
          text: this.$t("message.change_promotion_group_confirm", { name: this.account_id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmChangePromotionGroup();
          } else {
            this.promotion_group = this.memberProfile != null ? this.memberProfile.promotion_group : '';
          }
        });
    },
    confirmChangePromotionGroup: function() {
      let url = config.memberProfilePromotionGroupUpdateUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        member_id: this.account_id,
        promotion_group: this.promotion_group,
        audit_by: this.$store.getters.loginId,
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$helpers.showDialog(this.$t("ui.combine.change_promotion_group"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                //this.$emit("failed", "update_profile", this.feedback.status);
                // this.$refs.updateMemberProfile.hide();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    changeWithdrawalLimit(e) {
      // console.log(this.memberProfile, this.withdrawal_limit)
      this.$helpers
        .alert({
          title: this.$t("ui.withdrawal_limit"),
          text: this.$t("message.change_withdrawal_limit_confirm", { name: this.account_id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmChangeWithdrawalLimit();
          } else {
            this.withdrawal_limit = this.memberProfile != null ? this.memberProfile.withdrawal_limit : '';
          }
        });
    },
    confirmChangeWithdrawalLimit: function() {
      let url = config.memberProfileWithdrawalLimitUpdateUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        member_id: this.account_id,
        withdrawal_limit: this.withdrawal_limit,
        audit_by: this.$store.getters.loginId,
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$helpers.showDialog(this.$t("ui.combine.change_withdrawal_limit"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                //this.$emit("failed", "update_profile", this.feedback.status);
                // this.$refs.updateMemberProfile.hide();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    changeBankGroup() {
      this.$helpers
        .alert({
          title: this.$t("ui.bank_group"),
          text: this.$t("message.change_bank_group_confirm", { name: this.account_id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmChangeBankGroup();
          } else {
            this.bank_group = this.memberProfile != null ? this.memberProfile.bank_group : '';
          }
        });
    },
    confirmChangeBankGroup: function() {
      let url = config.memberProfileBankGroupUpdateUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        member_id: this.account_id,
        bank_group: this.bank_group,
        audit_by: this.$store.getters.loginId,
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$helpers.showDialog(this.$t("ui.combine.change_bank_group"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                //this.$emit("failed", "update_profile", this.feedback.status);
                // this.$refs.updateMemberProfile.hide();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    getPromotionGroupList: function() {
      let url = config.promotionGroupListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.pgOptions = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getWithdrawalLimitList: function() {
      let url = config.withdrawalLimitListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.wlOptions = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getBankGroupList: function() {
      let url = config.bankGroupListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.bgOptions = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getMemberProfile: function() {
      let url = config.memberProfileGetUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        member_id: this.item.account_id
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.memberProfile = (response.data.dt.length > 0) ? response.data.dt[0] : null;
                this.withdrawal_limit = this.memberProfile != null ? this.memberProfile.withdrawal_limit : '';
                this.bank_group = this.memberProfile != null ? this.memberProfile.bank_group : '';
                this.promotion_group = this.memberProfile != null ? this.memberProfile.promotion_group : '';
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.account_id = this.item.account_id;
      this.getMemberProfile();
      this.getPromotionGroupList();
      this.getWithdrawalLimitList();
      this.getBankGroupList();
    }
  }
};
</script>
